import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-gradient-to-b from-[#1B3A5C] to-[#0F2440] py-16 md:py-24 px-4" data-id="element-73">
      <div className="max-w-6xl mx-auto" data-id="element-74">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-75">
          {/* Text Content */}
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-76">
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-77">
              Deja de pagar la hipoteca de tu "landlord" y estrena tu propia
              casa en 90 días{' '}
              <span className="text-[#D4A843]" data-id="element-78">
                (aunque no tengas $50,000 ahorrados)
              </span>
              .
            </h1>

            <p className="text-lg md:text-xl text-white/70 mb-8 max-w-2xl lg:max-w-none" data-id="element-79">
              El sistema paso a paso para inquilinos hispanos en EE.UU. que
              quieren comprar su primera propiedad usando fondos de asistencia
              que el banco no te menciona.
            </p>

            <motion.a href="#oferta" className="inline-block bg-[#D4A843] text-[#0F2440] font-bold text-lg md:text-xl px-8 py-4 rounded-xl shadow-lg shadow-[#D4A843]/30" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} transition={{
            type: 'spring',
            stiffness: 400,
            damping: 17
          }} data-id="element-80">
              ¡QUIERO MI PLAN 0-DOWN AHORA!
            </motion.a>

            <div className="flex items-center justify-center lg:justify-start gap-2 mt-4 text-white/60 text-sm" data-id="element-81">
              <LockIcon className="w-4 h-4" data-id="element-82" />
              <span data-id="element-83">
                Acceso inmediato tras la compra. Tu información está 100%
                segura.
              </span>
            </div>
          </motion.div>

          {/* Product Image */}
          <motion.div className="flex-1 flex justify-center" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-84">
            <div className="relative" data-id="element-85">
              <div className="absolute inset-0 bg-[#D4A843]/20 blur-3xl rounded-full" data-id="element-86" />
              <img src="https://cdn.magicpatterns.com/uploads/8tDZeizM762SfSwQVKHwWY/El_Plan_0_Down_para_Inquilinos.png" alt="El Plan 0-Down para Inquilinos - Guía digital" className="relative w-full max-w-md lg:max-w-lg drop-shadow-2xl" data-id="element-87" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}